import CONFIG from "@bd-core/config";
import $ from "jquery";

export default class Tutorial {
    constructor() {
        this.elms = {
            tutorial: ".js-tutorial",
            btnOpenTutorial: ".js-tutorial-btn",
            btnCloseTutorial: ".js-tutorial-close",
            btnNextTutorial: ".js-next-tutorial",
            btnPrevTutorial: ".js-prev-tutorial",
            tutorialImage: ".tutorial__img",
            tutorialTitle: ".tutorial-title",
            tutorialDescription: ".tutorial-description",
            tutorialPopup: ".tutorial__popup",
        };

        this.roomId = false;
        this.currentStep = 1;
        this.isInitialized = false;

        return this;
    }

    init() {
        if (!CONFIG.game.tutorial || CONFIG.game.tutorial.length === 0) {
            $(this.elms.btnOpenTutorial).hide();
            $(this.elms.tutorial).hide();
            return;
        }

        this.render();
        if (this.isInitialized) return;

        this.registerEvents();

        // Check if user has watched tutorial
        if (!sessionStorage.getItem("is-watched-tutorial")) {
            $(this.elms.btnCloseTutorial).css("display", "none");
            this.openTutorial();
            sessionStorage.setItem("is-watched-tutorial", "true");
        }

        this.isInitialized = true;
    }

    render() {
        const tutorial = CONFIG.game.tutorial[0];
        const $tutorial = $(this.elms.tutorial).first(); // Only use the first tutorial element
        const totalSteps = CONFIG.game.tutorial.length;

        if (sessionStorage.getItem("is-watched-tutorial")) {
            $(this.elms.btnCloseTutorial).css("display", "flex");
        }

        this.currentStep = 1;
        $tutorial
            .attr("data-step", this.currentStep)
            .find(this.elms.tutorialImage)
            .attr("src", tutorial.image);
        $(this.elms.tutorialTitle).text(
            `Step ${this.currentStep}/${totalSteps}`,
        );
        $(this.elms.tutorialDescription).html(tutorial.description);

        $(this.elms.tutorialPopup).css("top", tutorial.position_top);
        $(this.elms.tutorialPopup).css("left", tutorial.position_left);
    }

    registerEvents() {
        const $document = $(document);

        // Use event delegation with .off() to prevent duplicate handlers
        $document
            .off("click", this.elms.btnNextTutorial)
            .on("click", this.elms.btnNextTutorial, this.onNext.bind(this));

        $document
            .off("click", this.elms.btnOpenTutorial)
            .on(
                "click",
                this.elms.btnOpenTutorial,
                this.openTutorial.bind(this),
            );

        $document
            .off("click", this.elms.btnCloseTutorial)
            .on("click", this.elms.btnCloseTutorial, this.onClose.bind(this));

        $document
            .off("click", this.elms.btnPrevTutorial)
            .on("click", this.elms.btnPrevTutorial, this.onPrevious.bind(this));
    }

    openTutorial() {
        const $tutorial = $(this.elms.tutorial).first(); // Only use the first tutorial element
        const $prevBtn = $(this.elms.btnPrevTutorial);

        this.currentStep = 1;
        $tutorial.addClass("is-open");
        $prevBtn.prop("disabled", true);
    }

    onClose(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const $tutorial = $(this.elms.tutorial).first();
        $tutorial.removeClass("is-open");
        this.render();
    }

    onNext(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event bubbling

        const $tutorial = $(this.elms.tutorial).first(); // Only use the first tutorial element
        const $prevBtn = $(this.elms.btnPrevTutorial);
        const totalSteps = CONFIG.game.tutorial.length;
        const nextStep = this.currentStep + 1;

        if (nextStep > totalSteps) {
            $tutorial.removeClass("is-open");
            this.render();
            return;
        }

        this.currentStep = nextStep;
        const tutorial = CONFIG.game.tutorial[nextStep - 1];
        $prevBtn.prop("disabled", false);
        $tutorial
            .attr("data-step", nextStep)
            .find(this.elms.tutorialImage)
            .attr("src", tutorial.image);
        $(this.elms.tutorialTitle).text(`Step ${nextStep}/${totalSteps}`);
        $(this.elms.tutorialDescription).html(tutorial.description);

        $(this.elms.tutorialPopup).css("top", tutorial.position_top);
        $(this.elms.tutorialPopup).css("left", tutorial.position_left);
    }

    onPrevious(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event bubbling

        const $tutorial = $(this.elms.tutorial).first(); // Only use the first tutorial element
        const $prevBtn = $(this.elms.btnPrevTutorial);
        const totalSteps = CONFIG.game.tutorial.length;
        const previousStep = this.currentStep - 1;

        if (previousStep < 1) {
            $tutorial.removeClass("is-open");
            return;
        }

        this.currentStep = previousStep;
        const tutorial = CONFIG.game.tutorial[previousStep - 1];
        if (this.currentStep === 1) {
            $prevBtn.prop("disabled", true);
        }
        $tutorial
            .attr("data-step", previousStep)
            .find(this.elms.tutorialImage)
            .attr("src", tutorial.image);
        $(this.elms.tutorialTitle).text(`Step ${previousStep}/${totalSteps}`);
        $(this.elms.tutorialDescription).html(tutorial.description);

        $(this.elms.tutorialPopup).css("top", tutorial.position_top);
        $(this.elms.tutorialPopup).css("left", tutorial.position_left);
    }
}
